
import { useRef, useState } from "react";
import { Avatar, Box, Button, Dialog, Tooltip, Slider } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import api from "../services/api";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import MessageAlert from "../messages/messageAlert";
import AvatarEditor from "react-avatar-editor";
import BottonLeft from "./buttonLeft";

const tamanhoImage = 270;

const useStyles = makeStyles({
    avatarContainer: {
        marginBottom: 10,
        display: 'flex',
        justifyContent: 'center',
    },
    avatar: {
        borderRadius: 5,
        transition: '.3s',
        '&:hover': {
            opacity: 0.5
        },
    },
})

function SimpleDialog(props) {
    const { onClose, open, submitEdit, setEdit, edit, classes, Foto, openLoad, messageSuccess, messageError, editorRef, scale, setScale } = props;

    const handleClose = () => { onClose(false); };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <div style={{ lineHeight: 1.5, padding: 10 }} align="center" >

                {messageSuccess && <MessageAlert type={'success'} message={messageSuccess} />}
                {messageError && <MessageAlert type={'error'} message={messageError} />}

                <Box className={classes.avatarContainer}>
                    <div>
                        {edit ?
                            <Avatar style={{ width: tamanhoImage, height: tamanhoImage }} variant="square" src={URL.createObjectURL(edit)} title="Clique para carregar uma imagem" />
                            :
                            <Avatar style={{ width: tamanhoImage, height: tamanhoImage }} variant="square" src={Foto} title="Clique para carregar uma imagem" />
                        }
                    </div>
                    <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="foto" style={{ display: 'none' }} onChange={(e) => setEdit(e.target.files[0])} />
                </Box>

                {edit && (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifySelf: 'center'
                            }}>
                            <AvatarEditor
                                ref={editorRef}
                                image={edit}
                                width={230}
                                height={230}
                                border={10}
                                borderRadius={0}
                                scale={scale}
                            />

                            <Slider
                                value={scale}
                                min={1}
                                max={3}
                                step={0.1}
                                onChange={(_, value) => setScale(value)}
                                valueLabelDisplay="auto"
                                sx={{ width: 240 }}
                            />
                        </div>
                    </>
                )}

                {edit ?
                    <BottonLeft
                        title={'Salvar'}
                        funcao={submitEdit}
                        disabled={openLoad}
                        load={openLoad}
                    >
                        <Button onClick={() => setEdit('')} color="error" >cancelar</Button>

                    </BottonLeft>
                    :
                    <Button autoFocus style={{ marginRight: 8 }} size="small" >
                        <label htmlFor="foto" style={{ cursor: 'pointer', textAlign: 'center' }}> Carregar imagem</label>
                    </Button>
                }

            </div>
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function FotoEdit({ dadosPessoal, openEditFoto, setOpenEditFoto, viewEdit }) {
    const editorRef = useRef(null);
    const classes = useStyles()
    const [Foto, setFoto] = useState(dadosPessoal?.fotoURL)
    const [edit, setEdit] = useState('');
    const [scale, setScale] = useState(1);
    const [openLoad, setOpenLoad] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const user = useSelector(state => state.account.user);

    const handleClose = () => {
        setOpenEditFoto && setOpenEditFoto(false);
        setEdit('')
    };

    const submitEdit = async () => {
        setOpenLoad(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('foto', edit);
        formData.append('dadosPessoaisId', dadosPessoal._id);
        formData.append('userId', user?._id ?? '');

        await api.patch('/dados-pessoais/change-foto', formData)
            .then(res => {
                // setOpenEditFoto(false);
                setOpenLoad(false)
                setFoto(res.data.dadosPessoais.fotoURL)
                setEdit('')
                setMessageSuccess('Sucesso.')
                // console.log(res)

            }).catch(err => {
                // console.log(err)
                setOpenLoad(false)
                setMessageError('Não foi possivel realizar esta ação.')
            })
    }

    return (
        <>
            <SimpleDialog
                classes={classes}
                Foto={Foto}
                open={openEditFoto}
                openLoad={openLoad}
                onClose={handleClose}
                submitEdit={submitEdit}
                edit={edit}
                setEdit={setEdit}
                messageSuccess={messageSuccess}
                messageError={messageError}
                editorRef={editorRef}
                scale={scale}
                setScale={setScale}
            />

            {/* user?.isAdmin &&  */}
            <Tooltip title={dadosPessoal?.nome}>
                <Box onClick={() => setOpenEditFoto && setOpenEditFoto(true)} className={classes.avatarContainer}>
                    {viewEdit === true ? '' : edit
                        ?
                        <Avatar style={{ width: tamanhoImage, height: tamanhoImage }} className={classes.avatar} variant="square" src={URL.createObjectURL(edit)} title="Clique para carregar uma imagem" />
                        :
                        <Avatar style={{ width: tamanhoImage, height: tamanhoImage, borderRadius: 5 }} className={classes.avatar} variant="square" src={Foto} title={user?.tipo === 'Admin' ? "Clique para carregar uma imagem" : ''} />
                    }
                </Box>
            </Tooltip>
        </>
    )
}